/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  AgentConversation,
  AuditEvent,
  AuditEventAction,
  AuditEventDetails,
  CreateOrganization,
  EntityId,
  JSONDocument,
  List,
  MemberRoleOrGuest,
  MergeRulesStandaloneConfiguration,
  Organization,
  OrganizationAISettingsUpdate,
  OrganizationAgentInstructions,
  OrganizationAllContent,
  OrganizationDefaultContent,
  OrganizationEmailDomains,
  OrganizationFeature,
  OrganizationHostname,
  OrganizationStyleguides,
  OrganizationSubscription,
  OrganizationSupportCost,
  OrganizationTitle,
  SearchSpaceResult,
  StyleguideTemplates,
  SubscriptionNotice,
  URL,
} from "./data-contracts";

/**
 * No description
 * @tags organizations, critical
 * @name ListOrganizationsForAuthenticatedUser
 * @summary Get the list of organizations for the currently authenticated user
 * @request GET:/orgs
 * @secure
 */

// @ts-ignore
export const listOrganizationsForAuthenticatedUser: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** The property to sort the list by. With `lastSeenAt`, only the organizations the user has opened are returned, most recently opened first. It returns at most `limit` items with no next page, and cannot be combined with `page`, because the order changes every time the user opens an organization. */
    sort?: "lastSeenAt";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Organization[];
  };
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs",
  method: "get",
  streaming: false,
  tags: ["organizations", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags organizations
 * @name CreateOrganization
 * @summary Create an organization
 * @request POST:/orgs
 * @secure
 */

// @ts-ignore
export const createOrganization: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {
    /** If true, also creates a default documentation site for the organization. */
    withDefaultSite?: boolean;
    /** URL of an OpenAPI/Swagger specification to import and attach to the default site as a reference. Only used when `withDefaultSite` is true. */
    openapiUrl?: string;
  };
  RequestBody: CreateOrganization;
  RequestHeaders: {};
  ResponseBody: Organization & {
    /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
    subscriptionNotice?: SubscriptionNotice;
  };
  ResponseStatusCode: 201;
} = {
  route: "/orgs",
  method: "post",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations, critical
 * @name GetOrganizationById
 * @summary Get an organization by its ID
 * @request GET:/orgs/{organizationId}
 * @secure
 */

// @ts-ignore
export const getOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Organization;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}",
  method: "get",
  streaming: false,
  tags: ["organizations", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags organizations, internal
 * @name DeleteOrganizationById
 * @summary Delete an organization
 * @request DELETE:/orgs/{organizationId}
 * @secure
 */

// @ts-ignore
export const deleteOrganizationById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}",
  method: "delete",
  streaming: false,
  tags: ["organizations", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations
 * @name UpdateOrganizationById
 * @summary Update an organization
 * @request PATCH:/orgs/{organizationId}
 * @secure
 */

// @ts-ignore
export const updateOrganizationById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the organization */
    title?: OrganizationTitle;
    emailDomains?: OrganizationEmailDomains;
    /** Default hostname for the organization's public content, e.g. <org-hostname>.gitbook.io */
    hostname?: OrganizationHostname;
    /** The role of a member in an organization, null for guests */
    defaultRole?: MemberRoleOrGuest;
    defaultContent?: OrganizationDefaultContent | null;
    logo?: URL | null;
    sso?: boolean;
    ai?: boolean;
    /** Partial AI preference update. Omitted keys are unchanged; null removes an opt-out. */
    aiSettings?: OrganizationAISettingsUpdate;
    inviteLinks?: boolean;
    mergeRules?: MergeRulesStandaloneConfiguration;
    supportCost?: OrganizationSupportCost | null;
  };
  RequestHeaders: {};
  ResponseBody: Organization;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}",
  method: "patch",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists all spaces, collections, sites accessible by current user in the current organization. This endpoint is internal for now as the data structure is optimized for the sidebar.
 * @tags organizations, critical, internal
 * @name GetOrganizationAllContent
 * @summary List all content in an organization
 * @request GET:/orgs/{organizationId}/content
 * @secure
 */

// @ts-ignore
export const getOrganizationAllContent: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationAllContent;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/content",
  method: "get",
  streaming: false,
  tags: ["organizations", "critical", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Lists the supported audit event action identifiers and their display labels. Access is restricted to organization administrators and GitBook staff. The organization must be activated and on an active Enterprise plan, except for GitBook's own organization.
 * @tags organizations
 * @name ListOrganizationAuditEventActions
 * @summary List organization audit event actions
 * @request GET:/orgs/{organizationId}/audit-event-actions
 * @secure
 */

// @ts-ignore
export const listOrganizationAuditEventActions: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: AuditEventAction[];
  };
  ResponseStatusCode: 200 | 401 | 403 | 404;
} = {
  route: "/orgs/{organizationId}/audit-event-actions",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists recorded changes for an activated organization. Access is restricted to organization administrators and GitBook staff, and results are ordered by occurrence time, newest first. An active Enterprise plan is required except for GitBook's own organization.
 * @tags organizations
 * @name ListOrganizationAuditEvents
 * @summary List organization audit events
 * @request GET:/orgs/{organizationId}/audit-events
 * @secure
 */

// @ts-ignore
export const listOrganizationAuditEvents: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * Number of events to return, up to 100.
     * @min 1
     * @max 100
     * @default 20
     */
    limit?: number;
    /**
     * Include events occurring at or after this time.
     * @format date-time
     */
    from?: string;
    /**
     * Include events occurring at or before this time.
     * @format date-time
     */
    to?: string;
    /** Filter by an exact audit action name. */
    action?: string;
    /** Filter by an exact stable actor identifier. */
    actor?: string;
    /** Filter by an exact stable target identifier. */
    target?: string;
    /** Include matching counts for action and actor options, excluding the option's own filter. */
    includeFacets?: boolean;
    /**
     * Include any of these action names. Combined with other filters using AND.
     * @maxItems 100
     */
    actions?: string[];
    /**
     * Include any of these stable actor identifiers, including system actors. Combined with other filters using AND.
     * @maxItems 100
     */
    actors?: string[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    facets?: {
      actions: Record<string, number>;
      actors: Record<string, number>;
    };
    items: AuditEvent[];
  };
  ResponseStatusCode: 200 | 400 | 401 | 403 | 404;
} = {
  route: "/orgs/{organizationId}/audit-events",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the full allowlisted payload for one recorded organization change. Access is restricted to organization administrators and GitBook staff. The organization must be activated and on an active Enterprise plan, except for GitBook's own organization.
 * @tags organizations
 * @name GetOrganizationAuditEvent
 * @summary Get an organization audit event
 * @request GET:/orgs/{organizationId}/audit-events/{auditEventId}
 * @secure
 */

// @ts-ignore
export const getOrganizationAuditEvent: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /**
     * Unique identifier of the audit event.
     * @format uuid
     */
    auditEventId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: AuditEventDetails;
  ResponseStatusCode: 200 | 401 | 403 | 404;
} = {
  route: "/orgs/{organizationId}/audit-events/{auditEventId}",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists every style guide (a space holding a team's writing style guide) in the organization, along with every site that references each one. Style guides that are not referenced by any site are still returned with an empty `sites` list.
 * @tags organizations
 * @name ListOrganizationStyleguides
 * @summary List all style guides in an organization
 * @request GET:/orgs/{organizationId}/styleguides
 * @secure
 */

// @ts-ignore
export const listOrganizationStyleguides: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationStyleguides;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/styleguides",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists the built-in style guide starter templates that can seed a new styleguide, including the markdown content used to render each template's preview.
 * @tags organizations
 * @name ListStyleguideTemplates
 * @summary List all built-in style guide templates
 * @request GET:/orgs/{organizationId}/styleguide-templates
 * @secure
 */

// @ts-ignore
export const listStyleguideTemplates: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: StyleguideTemplates;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/styleguide-templates",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns whether the organization is on a trial, the free plan or a paid plan, when its trial ends, and where to upgrade. Use it to answer questions about the plan or the trial, or to find how to upgrade.
 * @tags organizations
 * @name GetOrganizationSubscription
 * @summary Get an organization's subscription
 * @request GET:/orgs/{organizationId}/subscription
 * @secure
 */

// @ts-ignore
export const getOrganizationSubscription: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationSubscription;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/subscription",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations
 * @name DeleteOrganizationInviteById
 * @summary Deletes an organization invite.
 * @request DELETE:/orgs/{organizationId}/link-invites/{inviteId}
 * @secure
 */

// @ts-ignore
export const deleteOrganizationInviteById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the invite */
    inviteId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/link-invites/{inviteId}",
  method: "delete",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Join an organization if the user's verified email domain matches one of the organization's allowed email domains. This endpoint allows existing users to join organizations they're eligible for based on their email domain.
 * @tags organizations
 * @name JoinOrganization
 * @summary Join an organization
 * @request POST:/orgs/{organizationId}/join
 * @secure
 */

// @ts-ignore
export const joinOrganization: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/join",
  method: "post",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Send a request to ask the organization's admin to upgrade it.
 * @tags organizations, internal
 * @name RequestOrganizationUpgrade
 * @summary Request organization upgrade
 * @request POST:/orgs/{organizationId}/request_upgrade
 * @secure
 */

// @ts-ignore
export const requestOrganizationUpgrade: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** The feature key the user is asking an organization upgrade for */
    featureKey?: OrganizationFeature;
  };
  RequestHeaders: {};
  ResponseBody: object;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/request_upgrade",
  method: "post",
  streaming: false,
  tags: ["organizations", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations
 * @name SearchOrganizationContent
 * @summary Search content in an organization
 * @request GET:/orgs/{organizationId}/search
 * @secure
 */

// @ts-ignore
export const searchOrganizationContent: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** @maxLength 512 */
    query: string;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SearchSpaceResult[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/search",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations, agents
 * @name GetOrganizationAgentInstructions
 * @summary Get Docs agent instructions for an organization
 * @request GET:/orgs/{organizationId}/agent-instructions
 * @secure
 */

// @ts-ignore
export const getOrganizationAgentInstructions: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationAgentInstructions;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agent-instructions",
  method: "get",
  streaming: false,
  tags: ["organizations", "agents"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations, agents
 * @name UpdateOrganizationAgentInstructions
 * @summary Update Docs agent instructions for an organization
 * @request PUT:/orgs/{organizationId}/agent-instructions
 * @secure
 */

// @ts-ignore
export const updateOrganizationAgentInstructions: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Document describing the Docs agent instructions. */
    instructions: JSONDocument;
  };
  RequestHeaders: {};
  ResponseBody: OrganizationAgentInstructions;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agent-instructions",
  method: "put",
  streaming: false,
  tags: ["organizations", "agents"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of the calling user's AI agent conversations with the organization agent. Unlike change request conversations, these are not tied to a single change request: the agent works across the organization and only attaches a change request when it needs to edit content. A conversation belongs to the user who started it and is never visible to anyone else.
 * @tags organizations, agents
 * @name ListOrganizationAgentConversations
 * @summary List AI agent conversations in an organization
 * @request GET:/orgs/{organizationId}/agent/conversations
 * @secure
 */

// @ts-ignore
export const listOrganizationAgentConversations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: AgentConversation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agent/conversations",
  method: "get",
  streaming: false,
  tags: ["organizations", "agents"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Prepares a conversation so the client can connect to it, giving the agent the credentials it acts with. Call this before opening a conversation; connecting to one that was never provisioned yields an agent whose tools all fail. The conversation itself is only recorded once the user sends a first message, so opening the agent and closing it again leaves nothing behind. Safe to call again to refresh an expiring session.
 * @tags organizations, agents
 * @name ProvisionOrganizationAgentConversation
 * @summary Provision an AI agent conversation in an organization
 * @request PUT:/orgs/{organizationId}/agent/conversations/{conversationId}
 * @secure
 */

// @ts-ignore
export const provisionOrganizationAgentConversation: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the agent conversation (its client-generated local id, or "default" for the default conversation) */
    conversationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/agent/conversations/{conversationId}",
  method: "put",
  streaming: false,
  tags: ["organizations", "agents"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates one of the calling user's conversations with the organization agent. Use this to rename it.
 * @tags organizations, agents
 * @name UpdateOrganizationAgentConversation
 * @summary Update an AI agent conversation in an organization
 * @request PATCH:/orgs/{organizationId}/agent/conversations/{conversationId}
 * @secure
 */

// @ts-ignore
export const updateOrganizationAgentConversation: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the agent conversation (its client-generated local id, or "default" for the default conversation) */
    conversationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The new title of the conversation. */
    title: string;
  };
  RequestHeaders: {};
  ResponseBody: AgentConversation;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agent/conversations/{conversationId}",
  method: "patch",
  streaming: false,
  tags: ["organizations", "agents"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Deletes one of the calling user's conversations with the organization agent, destroying the messages it holds. This cannot be undone.
 * @tags organizations, agents
 * @name DeleteOrganizationAgentConversation
 * @summary Delete an agent conversation in an organization
 * @request DELETE:/orgs/{organizationId}/agent/conversations/{conversationId}
 * @secure
 */

// @ts-ignore
export const deleteOrganizationAgentConversation: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique ID of the agent conversation (its client-generated local id, or "default" for the default conversation) */
    conversationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 205;
} = {
  route: "/orgs/{organizationId}/agent/conversations/{conversationId}",
  method: "delete",
  streaming: false,
  tags: ["organizations", "agents"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations
 * @name GetOrganizationsForEmailDomain
 * @summary Get all organizations by email domain
 * @request GET:/email-domains/{emailDomain}/orgs
 * @secure
 */

// @ts-ignore
export const getOrganizationsForEmailDomain: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Email domain */
    emailDomain: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    organizations: Organization[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/email-domains/{emailDomain}/orgs",
  method: "get",
  streaming: false,
  tags: ["organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
